/**
 * "Conferência do CPF" no Conferir envio (E165.F1.T04, GUS-135, ADR-0114 §1): o CPF informado na
 * identificação contra o CPF do signatário lido dos arquivos, como o servidor o conferiu.
 *
 * - **Compatível**: o box verde "CPF compatível com os documentos".
 * - **Divergente**: o alerta, com "Corrigir identificação ou documentos", que volta ao Enviar; a
 *   conclusão fica travada, na tela e no servidor.
 * - **Não conferido** (a leitura não achou CPF do signatário, ou falhou): o aviso de que a equipe
 *   confere depois. Não trava — é o desvio deliberado do molde, registrado na ADR.
 *
 * Sem CPF informado (a abertura interna), o card não aparece.
 */
import { Badge, Button } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { EstadoDoCpf } from '@/lib/abertura_do_caso';

import { AvisoDaAbertura, CartaoDaAbertura } from './PecasDaAbertura';

const t = ptBR.abertura.conferirEnvio.cpf;

export function ConferenciaDoCpf({
  estado,
  onCorrigir,
}: {
  estado: EstadoDoCpf | null | undefined;
  onCorrigir: () => void;
}): JSX.Element | null {
  if (estado === null || estado === undefined) return null;
  return (
    <CartaoDaAbertura titulo={t.titulo} testId="conferir-cpf">
      {estado === 'compativel' ? (
        <Badge variant="ok" data-testid="conferir-cpf-compativel">
          {t.compativel}
        </Badge>
      ) : null}
      {estado === 'divergente' ? (
        // O `.notice.warn` do HTML 6.8 é a caixa neutra azulada (o tom "em andamento"), não amarela.
        <div
          role="alert"
          data-testid="conferir-cpf-divergente"
          className="border border-situacao-progress-border bg-situacao-progress-bg px-[14px] py-3 text-[14px] text-fg"
        >
          <p className="mb-[3px] font-display text-[15px] font-semibold">{t.divergenteTitulo}</p>
          <p>{t.divergenteTexto}</p>
          <Button
            type="button"
            variant="secondary"
            className="mt-sc-3"
            data-testid="conferir-cpf-corrigir"
            onClick={onCorrigir}
          >
            {t.corrigir}
          </Button>
        </div>
      ) : null}
      {estado === 'nao_conferido' ? (
        <AvisoDaAbertura
          tom="info"
          titulo={t.naoConferidoTitulo}
          texto={t.naoConferidoTexto}
          testId="conferir-cpf-nao-conferido"
        />
      ) : null}
    </CartaoDaAbertura>
  );
}
